const CHAT_SESSION_ID_KEY = 'synergi-chat-session-id';
const RESPONSE_HEADER_NAME = 'x-chat-session-id-generated';

const readChatSessionId = (): string | undefined => {
  try {
    return typeof sessionStorage !== 'undefined'
      ? sessionStorage.getItem(CHAT_SESSION_ID_KEY) || undefined
      : undefined;
  } catch {
    return undefined;
  }
};

const persistChatSessionId = (value: string): void => {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(CHAT_SESSION_ID_KEY, value);
    }
  } catch {
    // Best-effort; non-fatal if storage is unavailable.
  }
};

const clearPersistedChatSessionId = (): void => {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(CHAT_SESSION_ID_KEY);
    }
  } catch {
    // Best-effort; non-fatal if storage is unavailable.
  }
};

// Session ID is server-generated; we only store what the server provides
let currentChatSessionId: string | undefined = readChatSessionId();

export const getChatSessionId = (): string => currentChatSessionId ?? '';

/**
 * Captures a server-generated session ID from the response header.
 * Should be called after each API response to capture server-generated IDs.
 */
export const captureServerSessionId = (response: Response): void => {
  const serverSessionId = response.headers.get(RESPONSE_HEADER_NAME);
  if (serverSessionId && serverSessionId !== currentChatSessionId) {
    currentChatSessionId = serverSessionId;
    persistChatSessionId(serverSessionId);
  }
};

/**
 * Clears the current session ID. The server will generate a new one on the next request.
 */
export const resetChatSessionId = (): string => {
  currentChatSessionId = undefined;
  clearPersistedChatSessionId();
  return '';
};
